import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";

interface CustomDatePickerProps {
  dateFormat?: string;
  minDate?: Date | null;
  maxDate?: Date | null;
  placeholderText?: string;
  onChange?: (date: Date | null) => void;
  defaultDate?: Date | null;
  label?: string;
  required?: boolean;
  monthPicker?: boolean;
  showLabel?: boolean;
  className?: string;
  name?: string;
  disabled?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  dateFormat = "dd-MMM-yyyy",
  minDate: initialMinDate = null,
  maxDate: initialMaxDate = null,
  placeholderText = "Select date",
  label = "Select date",
  onChange,
  defaultDate = null,
  required = false,
  monthPicker = false,
  showLabel = true,
  className,
  name,
  disabled = false,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    if (onChange) {
      onChange(date);
    }
  };

  useEffect(() => {
    setSelectedDate(defaultDate);
  }, [defaultDate]);

  const updatedDateFormat = monthPicker ? "MMMM yyyy" : dateFormat;

  return (
    <div className="mf-admin-inputfield-container d-flex flex-column">
      {showLabel && (
        <label
          className="text-primary-color weight-400 text-capitalize mf-admin-inputfield-label mb-1"
          htmlFor="custom-datepicker"
        >
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <DatePicker
        id="custom-datepicker"
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat={updatedDateFormat}
        minDate={initialMinDate}
        maxDate={initialMaxDate}
        placeholderText={placeholderText}
        showMonthYearPicker={monthPicker}
        className={`mf-admin-inputfield ${className} `}
        name={name}
        disabled={disabled}
      />
    </div>
  );
};

export default CustomDatePicker;
